// NGRX
import {createFeatureSelector, createSelector} from '@ngrx/store';
// Lodash
import {each} from 'lodash';
// CRUD
import {QueryResultsModel, HttpExtenstionsModel} from '../../_base/crud';
import {ProductGroupModel} from '../_models/product-group.model';
import {ProductGroupsState} from '../_reducers/product-group.reducers';
// State

export const selectProductGroupsState = createFeatureSelector<ProductGroupsState>('productGroups');

export const selectProductGroupById = (productGroupId: number) => createSelector(
	selectProductGroupsState,
	productGroupsState => productGroupsState.entities[productGroupId]
);

export const selectProductGroupsPageLoading = createSelector(
	selectProductGroupsState,
	productGroupsState => productGroupsState.listLoading
);

export const selectProductGroupsActionLoading = createSelector(
	selectProductGroupsState,
	customersState => customersState.actionsloading
);

export const selectProductGroupsPageLastQuery = createSelector(
	selectProductGroupsState,
	productGroupsState => productGroupsState.lastQuery
);

export const selectLastCreatedProductGroupId = createSelector(
	selectProductGroupsState,
	productGroupsState => productGroupsState.lastCreatedProductGroupId
);

export const selectProductGroupsInitWaitingMessage = createSelector(
	selectProductGroupsState,
	productGroupsState => productGroupsState.showInitWaitingMessage
);

export const selectProductGroupsInStore = createSelector(
	selectProductGroupsState,
	productGroupsState => {
		const items: ProductGroupModel[] = [];
		each(productGroupsState.entities, element => {
			items.push(element);
		});
		const httpExtension = new HttpExtenstionsModel();
		const result: ProductGroupModel[] = httpExtension.sortArray(items, productGroupsState.lastQuery.sortField, productGroupsState.lastQuery.sortOrder);
		return new QueryResultsModel(result, productGroupsState.totalCount, '');
	}
);

export const selectHasProductGroupsInStore = createSelector(
	selectProductGroupsInStore,
	queryResult => {
		if (!queryResult.totalCount) {
			return false;
		}

		return true;
	}
);
